import { render, staticRenderFns } from "./e-organization-name-with-icon.vue?vue&type=template&id=f69aa6d0&scoped=true&lang=pug"
import script from "./e-organization-name-with-icon.vue?vue&type=script&lang=js"
export * from "./e-organization-name-with-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69aa6d0",
  null
  
)

export default component.exports